import { IState } from "../../Model/State/IState";

export function selectFilteredProjectIdsCount(state: IState): number {
  return selectFilterIdList(state).length;
}

export function selectFilterExpression(state: IState): string {
  return state.projects.filter.expression;
}

export function selectFilterKey(state: IState): string {
  return state.projects.filter.filterKey;
}

export function selectFilterIdList(state: IState): string[] {
  return state.projects.filter.idList;
}

export function selectFilterCount(state: IState): [string, number][] {
  return state.projects.filter.filterCount;
}
